import { SharingTipId } from '../../types/sharingTipId';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { assertNever } from 'owa-assert';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';

export interface InfoBarStringTemplates {
    singleFile: string;
    multipleFiles: string;
}

export function sharingTipIdToInfoBarString(
    sharingTipId: SharingTipId,
    recipientInfo: SharingTipRecipientInfo[]
): InfoBarStringTemplates {
    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
            return {
                singleFile: strings.NoPermissionToShareText,
                multipleFiles: strings.NoPermissionToShareText,
            };
        case SharingTipId.getSharingInfoFailed:
            return {
                singleFile: strings.NoSharingInfoText,
                multipleFiles: strings.NoSharingInfoText,
            };
        case SharingTipId.linkHasExpired:
            return {
                singleFile: strings.SingleLinkIsExpiredText,
                multipleFiles: strings.MultipleLinksAreExpiredText,
            };
        case SharingTipId.linkWillExpire:
            return {
                singleFile: strings.SingleLinkWillExpireText,
                multipleFiles: strings.MultipleLinksWillExpireText,
            };
        case SharingTipId.noPermissionToShareExternally:
            return {
                singleFile: strings.NoPermissionToShareExternallyText,
                multipleFiles: strings.NoPermissionToShareExternallyText,
            };
        case SharingTipId.externalRecipientCSL:
            return {
                singleFile: strings.WarningSharingCSLWithExternalRecipientsText,
                multipleFiles: strings.WarningSharingCSLWithExternalRecipientsText,
            };
        case SharingTipId.noPermissionSet:
            return {
                singleFile: strings.WarningSharingWithoutSettingPermissionsText,
                multipleFiles: strings.WarningSharingWithoutSettingPermissionsText,
            };
        case SharingTipId.sharingWithLargeDL:
            const bigDLNames: string = getBigDLNames(recipientInfo);
            return {
                singleFile: format(
                    strings.NoPermissionBigDLRecipientsText,
                    bigDLNames,
                    '{0}',
                    '{1}'
                ),
                multipleFiles: format(
                    strings.NoPermissionBigDLRecipientsText,
                    bigDLNames,
                    '{0}',
                    '{1}'
                ),
            };
        default:
            return assertNever(sharingTipId);
    }
}

const getBigDLNames = (recipientInfo: SharingTipRecipientInfo[] | null) => {
    if (recipientInfo) {
        const bigDLs = recipientInfo.filter(recipient => {
            return recipient.TotalMemberCount > 100;
        });
        return bigDLs.map(DL => DL.Name).join(', ');
    }
    return '';
};
